import { history } from './history';
import {
  STUDY_ERROR_REASON_PARAM,
  type StudyNotFoundReason,
} from './studyNotFound';
import { finalizeShareableQueryString } from './dicomStoreUrl';

/**
 * Navigate to the study-not-found / permission-denied page while preserving URL
 * query params (e.g. dicomStore) used by NotFoundStudy.
 */
export function redirectToNotFoundStudy(reason: StudyNotFoundReason = 'study-not-found') {
  const currentSearch = window.location.search || '';
  const searchParams = new URLSearchParams(currentSearch);
  searchParams.set(STUDY_ERROR_REASON_PARAM, reason);
  const search = `?${finalizeShareableQueryString(searchParams, null, currentSearch)}`;
  const pathname = '/notfoundstudy';

  if (history.navigate) {
    history.navigate({ pathname, search }, { replace: true });
    return;
  }

  window.location.assign(`${pathname}${search}`);
}
